import { Colors } from "../../../styles/theme";

type StatCard = {
  title: string;
  subtitle: string;
  detail: string;
  value?: string;
};

export function WelcomeStatCards({ cards }: { cards: StatCard[] }) {
  return (
    <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-3">
      {cards.map((c) => (
        <div
          key={c.title}
          className="rounded-[6px] border border-[#022A59] bg-white p-3 text-xl"
        >
          <div
            className={`text-xl font-bold`}
            style={{ color: Colors.AZUL_GOV_DARK }}
          >
            {c.title}
          </div>
          <div className="mt-1 text-sm" style={{ color: Colors.GRAY_DARK }}>{c.subtitle}</div>
          <div
            className="mt-1 text-sm"
            style={{ color: Colors.GRAY_DARK }}
          >
            {c.detail}
          </div>
        </div>
      ))}
    </div>
  );
}
